import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/Stockists/Add";
import { TableData } from "@/App/Stockists/Table";
import { getStockistsData, searchStockistsData } from "@/Api/stockists";
import { useAuth } from "@/hooks/auth";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";

export type TableDataProps = {
  id: number;
  uuid: string;
  user_id: number;
  phone: string;
  document: string;
  is_active: number;
  created_at: string;
  name: string;
  photo: string;
  email: string;
  user_type_id: number;
  address: {
    street: string;
    number: string;
    neighborhood: string;
    complement?: string;
    city: string;
    state: string;
    zip_code: string;
  };
  unity: {
    id: string;
    name: string;
  };
};

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const user = useAuth();
  const unityId = user?.user?.unity?.[0]?.id || "";
  const { hasPermission } = usePermissions();

  useEffect(() => {
    (async () => {
      const { data } = await getStockistsData(1, unityId);
      setListData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getStockistsData(
          listData?.current_page + 1,
          unityId
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getStockistsData(
          listData?.current_page - 1,
          unityId
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getStockistsData(listData?.last_page, unityId);
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("show-unit-responsible")}>
        <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
          <h2 className="text-2xl font-semibold flex gap-2 items-center">
            Estoquistas
          </h2>
          <AddBtn
            updateFront={async () => {
              const { data } = await getStockistsData(1, unityId);
              setListData(data?.response);
            }}
          />
        </div>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setListData}
            setState={setState}
            funcSearch={(params) =>
              searchStockistsData({ ...params, unity_id: unityId })
            }
            placeholder="Pesquisar estoquistas"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={6} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={async () => {
                const { data } = await getStockistsData(1, unityId);
                setListData(data?.response);
              }}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
